import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=1d2c212c&scoped=true&"
import script from "./MyCourses.vue?vue&type=script&lang=js&"
export * from "./MyCourses.vue?vue&type=script&lang=js&"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=1d2c212c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c212c",
  null
  
)

export default component.exports